<!-- 本科-个人信息页-基本信息 -->
<template>
  <div class='personal-detail-wrap'>
    <div class='detail-container has-border'>
      <div class='personal-detail en'
           v-if='!isEditEn'>
        <h4>Basic Info</h4>
        <ul>
          <li>
            <span class='personal-detail-name'>Last Name：</span>
            <span class='personal-detail-val'>{{ baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.lastName }}</span>
          </li>
          <li>
            <span class='personal-detail-name'>First Name：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.firstName}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Phone（Emergency use only）：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.phone}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Email：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.email}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>WeChat ID：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.weChat}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Linkedin：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.linkedin}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Current Living country：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.country}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Current Living state：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.province}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Current living city：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && baseInfoDetail.baseInfo.city}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Local time zone：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.businessInfo && baseInfoDetail.businessInfo.zone}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>English native speaker：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && (baseInfoDetail.baseInfo.englishSpeaker || baseInfoDetail.baseInfo.englishSpeaker === 0) && new Map(EnglishSpeakerEnMap).get(baseInfoDetail.baseInfo.englishSpeaker)}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Speak Chinese：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.baseInfo && (baseInfoDetail.baseInfo.chineseSpeaker || baseInfoDetail.baseInfo.chineseSpeaker === 0) && new Map(SpeakChineseEnMap).get(baseInfoDetail.baseInfo.chineseSpeaker)}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Undergrad School：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.eduInfo && baseInfoDetail.eduInfo.benkeUniver}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Undergrad College/Faculty：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.eduInfo && baseInfoDetail.eduInfo.ugdFaculty}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Undergrad Major：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.eduInfo && baseInfoDetail.eduInfo.benkeField}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Graduate School：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.eduInfo && baseInfoDetail.eduInfo.univer}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Graduate Major：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.eduInfo && baseInfoDetail.eduInfo.major}}</span>
          </li>
          <li>
            <span class='personal-detail-name'>Degree：</span>
            <span class='personal-detail-val'>{{baseInfoDetail.eduInfo && baseInfoDetail.eduInfo.degree && new Map(degreeEnMap).get(baseInfoDetail.eduInfo.degree)}}</span>
          </li>
        </ul>
      </div>
      <div class='personal-form en'
           v-if='isEditEn'>
        <h4>Basic Info</h4>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-item">
            <FormItem label="WeChat ID："
                      prop="weChat">
              <Input v-model="formValidateEn.weChat"
                     placeholder="please enter WeChat ID"></Input>
            </FormItem>
            <FormItem label="Linkedin："
                      prop="linkedin">
              <Input v-model="formValidateEn.linkedin"
                     placeholder="please enter linkedin"></Input>
            </FormItem>
            <div class='content-top'>
              <FormItem label="Current Living country："
                        prop="country"
                        class='margin-top'>
                <Input v-model="formValidateEn.country"
                       placeholder="please select country"></Input>
              </FormItem>
            </div>
            <FormItem label="Current Living state："
                      prop="province">
              <Input v-model="formValidateEn.province"
                     placeholder="please select state">
              </Input>
            </FormItem>
            <FormItem label="Current Living city："
                      prop="city">
              <Input v-model="formValidateEn.city"
                     placeholder="please select city">
              </Input>
            </FormItem>
            <FormItem label="Current Living zone："
                      prop="zone">
              <Select v-model="formValidateEn.zone"
                      placeholder="please select zone">
                <Option v-for="item in zoneEnMap"
                        :value="item.value"
                        :key="item.value">{{item.title}}
                </Option>
              </Select>
            </FormItem>
          </div>
          <div class="sub-btn">
            <Button :loading='hasSaveBaseInfo'
                    @click="saveEn">Save</Button>
          </div>
        </Form>
      </div>
      <div class='personal-btn en'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getBasicinfo, putBasicinfo } from '@/api/talents'
import { EnglishSpeakerEnMap, SpeakChineseEnMap, degreeEnMap, zoneEnMap } from '../constants'
import './personal-detail.less'
export default {
  name: '',
  components: {},
  data () {
    return {
      // English native speaker映射
      EnglishSpeakerEnMap,
      // Speak Chinese映射
      SpeakChineseEnMap,
      // Degree映射
      degreeEnMap,
      // loading-基本信息-避免重复提交
      hasSaveBaseInfo: false,
      // 时区映射
      zoneEnMap,
      // 基本信息详情
      baseInfoDetail: {},
      isEditEn: false,
      // En表单
      formValidateEn: {
        weChat: '',
        linkedin: '',
        country: '',
        province: '',
        city: '',
        zone: ''
      },
      ruleValidateEn: {
        weChat: [
          { required: true, message: 'please enter WeChat ID', trigger: 'blur' }
        ],
        linkedin: [
          { required: true, message: 'please enter linkedin', trigger: 'blur' }
        ],
        country: [
          { required: true, message: 'please select country', trigger: 'blur' }
        ],
        city: [
          { required: true, message: 'please select city', trigger: 'blur' }
        ],
        province: [
          { required: true, message: 'please select state', trigger: 'blur' }
        ],
        zone: [
          { required: true, message: 'please select zone', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  mounted () {
    this.getBasicinfoDetail()
  },
  methods: {
    // 获取基本信息详情
    getBasicinfoDetail () {
      getBasicinfo().then(res => {
        if (res.data.basicInfo) {
          this.baseInfoDetail = res.data.basicInfo
          if (res.data.basicInfo.baseInfo) {
            this.formValidateEn = res.data.basicInfo.baseInfo
          }
          if (res.data.basicInfo.businessInfo) {
            this.formValidateEn.zone = res.data.basicInfo.businessInfo.zone
          } else {
            this.formValidateEn.zone = ''
          }
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getBasicinfoDetail()
    },
    // Save
    saveEn () {
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          // 调用保存接口
          this.hasSaveBaseInfo = true
          putBasicinfo(this.formValidateEn).then(res => {
            this.hasSaveBaseInfo = false
            // 调用详情接口
            this.goEditEn()
          }).catch(error => {
            this.$ugd_message(error.message, 'error')
            this.hasSaveBaseInfo = false
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
